import { styled } from '@mui/material/styles';
import { HighlightLayerProps } from './HighlightLayer.props';


export const StyledHighlightedTextMarker = styled('div')<{ isCurrentHighlight: boolean }>(({ isCurrentHighlight }) => ({
  backgroundColor: '#fce4a9',
  display: 'inline',
  position: 'relative',
  ...(isCurrentHighlight && {
    outline: '2px solid #1976d2',
    outlineOffset: '0px',
  }),
  '& > span': {
    backgroundColor: 'inherit',
    display: 'inline',
    position: 'relative',
  },
}));


const HighlightLayer = ({ rects, isFocused, pageWidth, renderedWidth, focusedId }: HighlightLayerProps) => {
  const scale = renderedWidth / pageWidth;
  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
      }}>
      {rects.map((rect, i) => (
        <div
          key={i}
          id={i === 0 && focusedId ? focusedId : undefined}
          style={{
            position: 'absolute',
            left: `${rect.left * scale}px`,
            top: `${rect.top * scale}px`,
            width: `${rect.width * scale}px`,
            height: `${rect.height * scale}px`,
            backgroundColor: isFocused ? '#fce4a9' : 'yellow',
            outline: '2px solid #1976d2',
            mixBlendMode: 'multiply',
            transition: 'background-color 0.3s ease',
          }}
        />
      ))}
    </div>
  );
};

export default HighlightLayer;
